import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useWindowSize } from '~/src/hooks/index';

const SKUHeadingWrapper = ({ children, Offercard = false, ...rest }) => {
  const windowSize = useWindowSize();

  return (
    <AnimatePresence initial={false}>
      <motion.h3
        animate={windowSize.width >= 1440 ? { y: Offercard ? -450 : 0, opacity: 1 } : { y: Offercard ? -410 : 0 }}
        transition={{ duration: Offercard ? 1 : 0.3, ease: [0.25, 0.5, 0.75, 1] }}
        {...rest}>
        {children}
      </motion.h3>{' '}
    </AnimatePresence>
  );
};

export default SKUHeadingWrapper;
